import { render, staticRenderFns } from "./shift-time-value.vue?vue&type=template&id=bf0f5e08&scoped=true&"
import script from "./shift-time-value.vue?vue&type=script&lang=js&"
export * from "./shift-time-value.vue?vue&type=script&lang=js&"
import style0 from "./shift-time-value.vue?vue&type=style&index=0&id=bf0f5e08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0f5e08",
  null
  
)

export default component.exports